import { render, staticRenderFns } from "./ReportsDeliveryTrackingView.vue?vue&type=template&id=2c40f272"
import script from "./ReportsDeliveryTrackingView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryTrackingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports